import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-174e7bbf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "popularAccountsBox"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-174e7bbf><div class=\"col-12 col-sm colWithoutLeftPadding\" data-v-174e7bbf><div class=\"firstLine da-skeleton-loader\" data-v-174e7bbf></div><div class=\"secondLine da-skeleton-loader\" data-v-174e7bbf></div><div class=\"firstLine da-skeleton-loader\" data-v-174e7bbf></div><div class=\"secondLine da-skeleton-loader\" data-v-174e7bbf></div><div class=\"firstLine da-skeleton-loader\" data-v-174e7bbf></div><div class=\"secondLine da-skeleton-loader\" data-v-174e7bbf></div><div class=\"secondLine da-skeleton-loader\" data-v-174e7bbf></div></div></div>", 1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.itemsRendered)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.popularAccountsComponent), {
          ads: _ctx.adsInstance,
          bank: _ctx.bank,
          popularAccounts: _ctx.popularAccounts
        }, null, 8, ["ads", "bank", "popularAccounts"]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
}